/// AXIOS ///
import axios from "axios";
import { AxiosError } from "axios";
/// REDUX ///
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
/// ACTIONS ///
import { Action } from "api/action_types/shop_quote";
import { Action as AuthAction } from "api/action_types/authentication";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/shop_quote";
import { ActionType as AuthActionType } from "api/action_types/authentication";
/// TYPES ///
import { IShopQuoteLineItem } from "api/types/shop_quote/quote_line_item";
/// URLS ///
import { url_prefix } from "settings";
import { shop_quote_line_item_url } from "../endpoints";

export const updateShopQuoteLineItem = (quote_line_item: IShopQuoteLineItem, id: number) => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {

    const { user } = getState().authentication;

    dispatch({
      type: ActionType.SHOP_QUOTE_UPDATING
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    let url = `${url_prefix}${shop_quote_line_item_url}/${id ? id : 0}/`;

    try {
      const { data } = await axios.patch(url, quote_line_item, config);

      dispatch({
        type: ActionType.UPDATE_SHOP_QUOTE_LINE_ITEM,
        payload: data.line_item
      });

      dispatch({
        type: ActionType.UPDATE_SHOP_QUOTE,
        payload: data.quote
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.SHOP_QUOTE_ERROR,
          payload: "There was an error saving the sink."
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
